export default "__VITE_ASSET__CL7cSS7d__"